import CodeMirror from "@uiw/react-codemirror";
import { java } from "@codemirror/lang-java";
import { css } from "@codemirror/lang-css";
import { javascript } from "@codemirror/lang-javascript";
import { html } from "@codemirror/lang-html";
import { okaidia } from "@uiw/codemirror-theme-okaidia";
import styles from "./Editor.module.css";
import { useEffect, useRef, useState } from "react";
export default function Editor({ onChange, code, lang }) {
    const [currentCode, setCurrentCode] = useState(
        getItem("item") ? getItem("item") : ""
    );
    const iframeRef = useRef(null);
    useEffect(() => {
        const doc = iframeRef.current.contentWindow.document;
        doc.open();
        doc.write(currentCode);
        doc.close();
        //setCurrentCode(currentCode);
    }, [currentCode]);

    const handleEditorChange = (item) => {
        // Update the state with the current code
        setCurrentCode(item);
        console.log(item);
        saveItem(item);
    };
    function saveItem(item) {
        localStorage.setItem("item", item);
    }
    function getItem(key) {
        const obj = localStorage.getItem(key, "");
        return obj;
    }

    let languageExtension;
    // Determine the language extension based on the 'language' prop
    if (lang === "css") {
        languageExtension = css({ jsx: true });
    } else if (lang === "html") {
        languageExtension = html({ jsx: true });
    } else if (lang === "java") {
        languageExtension = java({ jsx: true });
    } else if (lang === "javascript") {
        languageExtension = javascript({ jsx: true });
    } else {
        // Default to a specific language if 'language' prop is not provided
        languageExtension = css({ jsx: true });
    }

    return (
        <div className={styles.container}>
            <div
                style={{
                    position: "fixed",
                    left: "-400px",
                    top: "10px",
                    zIndex: "100",
                }}
            >
                <div style={{ top: "block", float: "left", width: "100%" }}>
                    <img
                        src="/images/logo.webp"
                        alt="back"
                        style={{
                            width: "10%",
                        }}
                    />
                </div>
            </div>
            <div style={{ fontSize: "30px", padding: "10px" }}>
                <span>Start coding </span>
                <span style={{ color: "red" }}>| powered by wawiwa</span>
            </div>
            <div
                style={{
                    position: "fixed",
                    right: "-900px",
                    top: "10px",
                    zIndex: "100",
                }}
            >
                <div style={{ top: "block", float: "left", width: "100%" }}>
                    <img
                        src="/images/logo-a.png"
                        alt="back"
                        style={{
                            width: "4%",

                        }}
                    />
                </div>
            </div>

            <div className={styles.lang}>{"html/css/javascript"}</div>
            <div className={styles.mirror}>
                {
                    <CodeMirror
                        value={currentCode ? currentCode : ""}
                        height="1500px"
                        extensions={[languageExtension]} // Use the determined language extension
                        onChange={handleEditorChange}
                        theme={okaidia}
                        style={{ textAlign: "left" }} // Override text alignment
                    />
                }
            </div>
            <iframe
                className={styles.iframe}
                ref={iframeRef}
                sandbox="allow-same-origin allow-popups"
            ></iframe>
        </div>
    );
}
